import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
// TODO: when refactor this service from BE team will done,
//  then should update link from <a> to Button, in AdminButtons.tsx file
class ImageImportAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "clearImageCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId) => this.request('get', `invalidate-cache/${carId}`)
        });
        this.setConfig(config);
    }
}
export default new ImageImportAPI({
    baseURL: config.imagesAPI.imgUrlImport
});
